#import "../nut-email-address-fragment.graphql"

fragment EmailFragmentSparse on Email {
    id
    subject
    bodyExcerpt
    emailBodyHtml: bodyHtml
    originatedVia
    attachments {
        fileId
        name
        href
        fileType
    }
    isShared
    isShareable
    isAutomatedReply
    isEmailAutomation
    isTicketMessage
    ticketId
    ticketUrl
    trackedViewsCount
    trackedClicksCount
    recipients {
        ...NutEmailAddressFragment
    }
    from {
        ...NutEmailAddressFragment
    }
    isInbound
    isOutbound
    isFailed
    isReplyable
    isNutshellMarketingEmail
    htmlUrl
    htmlUrlPath
    edition {
        id
        name
    }
    sentWithinLastWeek
    hasAcceptedSuggestion
}
